'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';

const privateMap = util.createPrivateMapper();

export class RelativeContainer {
  constructor(containerDomEl){
    this.containerDomEl = containerDomEl;
    const pv = privateMap(this);
    pv.domEl = document.createElement('div');
    domUtil.setStyle(pv.domEl, 'position', 'relative');
    domUtil.setTop(pv.domEl, '0');
    domUtil.setLeft(pv.domEl, '0');
    this.containerDomEl.insertBefore(pv.domEl, this.containerDomEl.firstChild);

    this.applySize();
    // pv.size = domUtil.getSize(this.containerDomEl);
    // domUtil.setSize(pv.domEl, pv.size);
  }
  get domEl(){
    return privateMap(this).domEl;
  }
  get size(){
    return privateMap(this).size;
  }
  applySize(){
    const pv = privateMap(this);
    pv.size = domUtil.getSize(this.containerDomEl);
    domUtil.setSize(pv.domEl, pv.size);
  }
}
